/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {HarvestDemandPost} from '../bioplanModels';
// @ts-ignore
import type {HarvestDemandPut} from '../bioplanModels';
// @ts-ignore
import type {HarvestDemandResponse} from '../bioplanModels';
/**
 * PlanningHarvestDemandApi - axios parameter creator
 * @export
 */
export const PlanningHarvestDemandApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all harvest demands for a plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestDemandsGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('harvestDemandsGet', 'planId', planId);
      const localVarPath = `/harvestDemands/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete harvest demand by its identifier
     * @param {string} harvestDemandId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestDemandsHarvestDemandIdDelete: async (
      harvestDemandId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestDemandId' is not null or undefined
      assertParamExists('harvestDemandsHarvestDemandIdDelete', 'harvestDemandId', harvestDemandId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('harvestDemandsHarvestDemandIdDelete', 'planId', planId);
      const localVarPath = `/harvestDemands/{harvestDemandId}`.replace(
        `{${'harvestDemandId'}}`,
        encodeURIComponent(String(harvestDemandId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get harvest demand by its identifier.
     * @param {string} harvestDemandId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestDemandsHarvestDemandIdGet: async (
      harvestDemandId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestDemandId' is not null or undefined
      assertParamExists('harvestDemandsHarvestDemandIdGet', 'harvestDemandId', harvestDemandId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('harvestDemandsHarvestDemandIdGet', 'planId', planId);
      const localVarPath = `/harvestDemands/{harvestDemandId}`.replace(
        `{${'harvestDemandId'}}`,
        encodeURIComponent(String(harvestDemandId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update harvest demand
     * @param {string} harvestDemandId
     * @param {HarvestDemandPut} harvestDemandPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestDemandsHarvestDemandIdPut: async (
      harvestDemandId: string,
      harvestDemandPut: HarvestDemandPut,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestDemandId' is not null or undefined
      assertParamExists('harvestDemandsHarvestDemandIdPut', 'harvestDemandId', harvestDemandId);
      // verify required parameter 'harvestDemandPut' is not null or undefined
      assertParamExists('harvestDemandsHarvestDemandIdPut', 'harvestDemandPut', harvestDemandPut);
      const localVarPath = `/harvestDemands/{harvestDemandId}`.replace(
        `{${'harvestDemandId'}}`,
        encodeURIComponent(String(harvestDemandId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(harvestDemandPut, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create harvest demand for plan
     * @param {HarvestDemandPost} harvestDemandPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestDemandsPost: async (
      harvestDemandPost: HarvestDemandPost,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestDemandPost' is not null or undefined
      assertParamExists('harvestDemandsPost', 'harvestDemandPost', harvestDemandPost);
      const localVarPath = `/harvestDemands/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(harvestDemandPost, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningHarvestDemandApi - functional programming interface
 * @export
 */
export const PlanningHarvestDemandApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningHarvestDemandApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get all harvest demands for a plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestDemandsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HarvestDemandResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestDemandsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestDemandApi.harvestDemandsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete harvest demand by its identifier
     * @param {string} harvestDemandId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestDemandsHarvestDemandIdDelete(
      harvestDemandId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestDemandsHarvestDemandIdDelete(
        harvestDemandId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestDemandApi.harvestDemandsHarvestDemandIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get harvest demand by its identifier.
     * @param {string} harvestDemandId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestDemandsHarvestDemandIdGet(
      harvestDemandId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestDemandResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestDemandsHarvestDemandIdGet(
        harvestDemandId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestDemandApi.harvestDemandsHarvestDemandIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update harvest demand
     * @param {string} harvestDemandId
     * @param {HarvestDemandPut} harvestDemandPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestDemandsHarvestDemandIdPut(
      harvestDemandId: string,
      harvestDemandPut: HarvestDemandPut,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestDemandResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestDemandsHarvestDemandIdPut(
        harvestDemandId,
        harvestDemandPut,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestDemandApi.harvestDemandsHarvestDemandIdPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create harvest demand for plan
     * @param {HarvestDemandPost} harvestDemandPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestDemandsPost(
      harvestDemandPost: HarvestDemandPost,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestDemandResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestDemandsPost(harvestDemandPost, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestDemandApi.harvestDemandsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningHarvestDemandApi - factory interface
 * @export
 */
export const PlanningHarvestDemandApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningHarvestDemandApiFp(configuration);
  return {
    /**
     *
     * @summary Get all harvest demands for a plan
     * @param {PlanningHarvestDemandApiHarvestDemandsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestDemandsGet(
      requestParameters: PlanningHarvestDemandApiHarvestDemandsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<HarvestDemandResponse>> {
      return localVarFp
        .harvestDemandsGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete harvest demand by its identifier
     * @param {PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestDemandsHarvestDemandIdDelete(
      requestParameters: PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .harvestDemandsHarvestDemandIdDelete(requestParameters.harvestDemandId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get harvest demand by its identifier.
     * @param {PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestDemandsHarvestDemandIdGet(
      requestParameters: PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestDemandResponse> {
      return localVarFp
        .harvestDemandsHarvestDemandIdGet(requestParameters.harvestDemandId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update harvest demand
     * @param {PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestDemandsHarvestDemandIdPut(
      requestParameters: PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestDemandResponse> {
      return localVarFp
        .harvestDemandsHarvestDemandIdPut(
          requestParameters.harvestDemandId,
          requestParameters.harvestDemandPut,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create harvest demand for plan
     * @param {PlanningHarvestDemandApiHarvestDemandsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestDemandsPost(
      requestParameters: PlanningHarvestDemandApiHarvestDemandsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestDemandResponse> {
      return localVarFp
        .harvestDemandsPost(requestParameters.harvestDemandPost, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for harvestDemandsGet operation in PlanningHarvestDemandApi.
 * @export
 * @interface PlanningHarvestDemandApiHarvestDemandsGetRequest
 */
export interface PlanningHarvestDemandApiHarvestDemandsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestDemandApiHarvestDemandsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for harvestDemandsHarvestDemandIdDelete operation in PlanningHarvestDemandApi.
 * @export
 * @interface PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdDeleteRequest
 */
export interface PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdDelete
   */
  readonly harvestDemandId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for harvestDemandsHarvestDemandIdGet operation in PlanningHarvestDemandApi.
 * @export
 * @interface PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdGetRequest
 */
export interface PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdGet
   */
  readonly harvestDemandId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for harvestDemandsHarvestDemandIdPut operation in PlanningHarvestDemandApi.
 * @export
 * @interface PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdPutRequest
 */
export interface PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdPut
   */
  readonly harvestDemandId: string;

  /**
   *
   * @type {HarvestDemandPut}
   * @memberof PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdPut
   */
  readonly harvestDemandPut: HarvestDemandPut;
}

/**
 * Request parameters for harvestDemandsPost operation in PlanningHarvestDemandApi.
 * @export
 * @interface PlanningHarvestDemandApiHarvestDemandsPostRequest
 */
export interface PlanningHarvestDemandApiHarvestDemandsPostRequest {
  /**
   *
   * @type {HarvestDemandPost}
   * @memberof PlanningHarvestDemandApiHarvestDemandsPost
   */
  readonly harvestDemandPost: HarvestDemandPost;
}

/**
 * PlanningHarvestDemandApi - object-oriented interface
 * @export
 * @class PlanningHarvestDemandApi
 * @extends {BaseAPI}
 */
export class PlanningHarvestDemandApi extends BaseAPI {
  /**
   *
   * @summary Get all harvest demands for a plan
   * @param {PlanningHarvestDemandApiHarvestDemandsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestDemandApi
   */
  public harvestDemandsGet(
    requestParameters: PlanningHarvestDemandApiHarvestDemandsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestDemandApiFp(this.configuration)
      .harvestDemandsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete harvest demand by its identifier
   * @param {PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestDemandApi
   */
  public harvestDemandsHarvestDemandIdDelete(
    requestParameters: PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestDemandApiFp(this.configuration)
      .harvestDemandsHarvestDemandIdDelete(requestParameters.harvestDemandId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get harvest demand by its identifier.
   * @param {PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestDemandApi
   */
  public harvestDemandsHarvestDemandIdGet(
    requestParameters: PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestDemandApiFp(this.configuration)
      .harvestDemandsHarvestDemandIdGet(requestParameters.harvestDemandId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update harvest demand
   * @param {PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestDemandApi
   */
  public harvestDemandsHarvestDemandIdPut(
    requestParameters: PlanningHarvestDemandApiHarvestDemandsHarvestDemandIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestDemandApiFp(this.configuration)
      .harvestDemandsHarvestDemandIdPut(requestParameters.harvestDemandId, requestParameters.harvestDemandPut, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create harvest demand for plan
   * @param {PlanningHarvestDemandApiHarvestDemandsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestDemandApi
   */
  public harvestDemandsPost(
    requestParameters: PlanningHarvestDemandApiHarvestDemandsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestDemandApiFp(this.configuration)
      .harvestDemandsPost(requestParameters.harvestDemandPost, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
